"use strict";

import Vue from 'vue';
import axios from "axios";


let config = {
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 60 * 1000, // Timeout
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: false, // Check cross-site Access-Control 
    ransformRequest: [function (data) {
        // 做任何你想要的数据转换
        return data;
    }],

    transformResponse: [function (data) {
        // 预留后期过滤
        // return typeof data === "string"&&data !=="" ? JSON.parse(data) : null;
        return data
    }],
    validateStatus: function (status) {
        return status >= 200 && status <= 500; // default
    },


};
const _axios = axios.create(config);

// axios请求拦截
_axios.interceptors.request.use(
    function (config) {
        // Do something before request is sent
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// axios 请求响应拦截处理error事件
_axios.interceptors.response.use(
    response => {
        try {
            if (response.status == 200 && typeof response.data != "object") {
                response.data = JSON.parse(response.data)
            }
        } catch (error) {
            console.log(error)
        }
        return response
    },
    error => {
        try {
            switch (error.response.status) {
                case 403:
                case 401:
                case 402:
                    Vue.$vux.toast.show({
                        text: '您没有权限访问该页面'
                    })
                    break
                case 404:
                    Vue.$vux.toast.show({
                        text: '您访问的路径不存在'
                    })
                    break
                case 500:
                    Vue.$vux.toast.show({
                        text: '服务器崩溃了T T'
                    })
                    break
                default:
                    Vue.$vux.toast.show({
                        text: '网络异常T T'
                    })
            }
        } catch (e) {
            console.log(e)
        }

    }
)

Plugin.install = function (Vue) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        },
    });
};
Vue.use(Plugin)
export default _axios;